module.exports = __webpack_public_path__ + "warehouse.png?f27a3830f10827ab7afba194fa5a4279";